import { isDefinedAndNotNull } from '../../../app/_utils/isDefinedAndNotNull'
import {
  EmbroiderableProductFlatlayImage,
  EmbroideryPlacementDetails,
  ProductColor,
} from '../../../types/graphql'

export function getFlatlayImage({
  images,
  placement,
  productColor,
}: {
  images: Array<EmbroiderableProductFlatlayImage> | undefined
  placement: EmbroideryPlacementDetails | null
  productColor: Pick<ProductColor, 'name'> | undefined
}): EmbroiderableProductFlatlayImage | undefined {
  const list = images?.filter(isDefinedAndNotNull).filter(o => 'color' in o) ?? []
  return (
    list.find(o => o.kind === placement?.flatlayKind && o.color === productColor?.name) ??
    list.find(o => o.kind === placement?.flatlayKind && o.color === 'default') ??
    list.find(o => o.kind === 'flatlay-default' && o.color === productColor?.name) ??
    list.find(o => o.kind === 'flatlay-default' && o.color === 'default') ??
    list.find(o => o.kind === 'flatlay-default')
  )
}
